import { ReactElement, useMemo, useState } from 'react';

import AttendedWidgets from '@/modules/workforce/workersTimesheet/components/AttendedWidgets';
import Header from '@/modules/workforce/workersTimesheet/components/Header';
import TimesheetTable from '@/modules/workforce/workersTimesheet/components/TimesheetTable';
import { getLocalizedDate } from '@/shared/lib/dates';

export default function WorkersTimesheet(): ReactElement {
  const [date, setDate] = useState(new Date());
  const formatedDate = useMemo(
    () => getLocalizedDate({ date, formatDate: 'yyyy-MM-dd' }),
    [date]
  );
  return (
    <section>
      <Header date={date} setDate={setDate} />
      <AttendedWidgets date={formatedDate} />
      <TimesheetTable date={formatedDate} />
    </section>
  );
}
